import PermissionError from '../../PermissionError'
import EntityFieldInputGroup from '../shared/EntityFieldInputGroup'
import PageLayout from '../shared/PageLayout'
import useEntityEdit from '../shared/useEntityEdit'
import { KindEditPageProps } from '../KindPages'
import computeLabel from '../shared/computeLabel'

const DefaultEditPage = ({ entity, entityId, entityType, entityTypes, loading }: KindEditPageProps) => {
  const { fields, updateField, submitting, valid, submitEntity, deleteEntity, hasPermissions, permissionsLoading } =
    useEntityEdit({
      entity,
      entityId,
      entityType,
    })

  if (!hasPermissions && !loading && !permissionsLoading) {
    return <PermissionError missingPermittedActions={[]} />
  }

  const label = computeLabel(entityType, fields)

  return (
    <PageLayout
      title={label ?? entityType.name}
      subtitle={label ? entityType.name : undefined}
      showCancel
      showSave
      showDelete={!!entity}
      saveDisabled={!valid}
      submitting={submitting}
      onSave={submitEntity}
      onDelete={deleteEntity}
    >
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto', paddingTop: 12 }}>
        <EntityFieldInputGroup
          entityType={entityType}
          entityTypes={entityTypes}
          fields={fields}
          updateField={updateField}
          loading={loading}
        />
      </div>
    </PageLayout>
  )
}

export default DefaultEditPage
